import {jsx as $6Dj3b$jsx, jsxs as $6Dj3b$jsxs, Fragment as $6Dj3b$Fragment} from "react/jsx-runtime";
import {Breadcrumbs as $6Dj3b$Breadcrumbs, Breadcrumb as $6Dj3b$Breadcrumb, Link as $6Dj3b$Link, TextField as $6Dj3b$TextField, Input as $6Dj3b$Input, Label as $6Dj3b$Label, FieldError as $6Dj3b$FieldError, Text as $6Dj3b$Text, Select as $6Dj3b$Select, Button as $6Dj3b$Button, SelectValue as $6Dj3b$SelectValue, Popover as $6Dj3b$Popover, ListBox as $6Dj3b$ListBox, TextArea as $6Dj3b$TextArea} from "react-aria-components";
import $6Dj3b$react, {forwardRef as $6Dj3b$forwardRef, createContext as $6Dj3b$createContext, useMemo as $6Dj3b$useMemo, useContext as $6Dj3b$useContext, Fragment as $6Dj3b$Fragment1} from "react";
import {baseStyleProps as $6Dj3b$baseStyleProps, useSlotProps as $6Dj3b$useSlotProps, useStyleProps as $6Dj3b$useStyleProps} from "@react-spectrum/utils";
import {filterDOMProps as $6Dj3b$filterDOMProps} from "@react-aria/utils";
import $6Dj3b$clsx from "clsx";
import $6Dj3b$classnames from "classnames";
import {map as $6Dj3b$map, find as $6Dj3b$find, keys as $6Dj3b$keys, endsWith as $6Dj3b$endsWith} from "lodash";








const $831ef06765710a2e$var$FlattenToAppURLContext = /*#__PURE__*/ (0, $6Dj3b$createContext)({
    flattenToAppURL: (path)=>path
});
function $831ef06765710a2e$export$dccdf695657a545e(props) {
    let { children: children, flattenToAppURL: flattenToAppURL } = props;
    let ctx = (0, $6Dj3b$useMemo)(()=>({
            flattenToAppURL: flattenToAppURL
        }), [
        flattenToAppURL
    ]);
    return /*#__PURE__*/ (0, $6Dj3b$jsx)($831ef06765710a2e$var$FlattenToAppURLContext.Provider, {
        value: ctx,
        children: children
    });
}
function $831ef06765710a2e$export$b0c945b8a6993b4d() {
    return (0, $6Dj3b$useContext)($831ef06765710a2e$var$FlattenToAppURLContext);
}


const $e0ad75fff14524ce$var$Link = (props, ref)=>{
    const { flattenToAppURL: flattenToAppURL } = (0, $831ef06765710a2e$export$b0c945b8a6993b4d)();
    const flattenedURL = flattenToAppURL(props.href);
    return /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$Link), {
        ref: ref,
        ...props,
        href: flattenedURL,
        children: props.children
    });
};
const $e0ad75fff14524ce$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $6Dj3b$forwardRef)($e0ad75fff14524ce$var$Link);







function $c4f5db3caac4ef5a$var$iconColorValue(value) {
    return `var(--semantic-${value}-color-icon)`;
}
const $c4f5db3caac4ef5a$var$iconStyleProps = {
    ...(0, $6Dj3b$baseStyleProps),
    color: [
        "color",
        $c4f5db3caac4ef5a$var$iconColorValue
    ]
};
function $c4f5db3caac4ef5a$export$2e2bcd8739ae039(props) {
    props = (0, $6Dj3b$useSlotProps)(props, "icon");
    let { children: children, size: size, "aria-label": ariaLabel, "aria-hidden": ariaHidden, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $6Dj3b$useStyleProps)(otherProps, $c4f5db3caac4ef5a$var$iconStyleProps);
    if (!ariaHidden) ariaHidden = undefined;
    let iconSize = size ? size : "M";
    return /*#__PURE__*/ (0, $6Dj3b$react).cloneElement(children, {
        ...(0, $6Dj3b$filterDOMProps)(otherProps),
        ...styleProps,
        focusable: "false",
        "aria-label": ariaLabel,
        "aria-hidden": ariaLabel ? ariaHidden || undefined : true,
        role: "img",
        className: (0, $6Dj3b$clsx)("q icon", `icon--size${iconSize}`, children.props.className, styleProps.className)
    });
}


const $40b74fc137e2741c$var$HomeIcon = (props)=>{
    return /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $c4f5db3caac4ef5a$export$2e2bcd8739ae039), {
        ...props,
        children: /*#__PURE__*/ (0, $6Dj3b$jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "home-icon",
            children: /*#__PURE__*/ (0, $6Dj3b$jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.5855 9.68946L12 2.7666L2.41455 9.68946L3.58553 11.3108L12 5.23367L20.4146 11.3108L21.5855 9.68946ZM7 12.0001H5V21.0001H11V16.0001H13V21.0001H19V12.0001H17V19.0001H15V14.0001H9V19.0001H7V12.0001Z"
            })
        })
    });
};
var $40b74fc137e2741c$export$2e2bcd8739ae039 = $40b74fc137e2741c$var$HomeIcon;


function $6b2a92710cce9598$export$2e2bcd8739ae039({ items: items, root: root, includeRoot: includeRoot }) {
    let itemsWithRoot;
    if (includeRoot) {
        const rootItem = {
            "@id": root || "/",
            title: "Home"
        };
        itemsWithRoot = [
            rootItem,
            ...items
        ];
    }
    return /*#__PURE__*/ (0, $6Dj3b$jsx)("nav", {
        "aria-label": "breadcrumbs",
        role: "navigation",
        children: /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$Breadcrumbs), {
            className: "q breadcrumbs",
            items: itemsWithRoot || items,
            children: (item)=>/*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$Breadcrumb), {
                    className: "q breadcrumb",
                    children: /*#__PURE__*/ (0, $6Dj3b$jsxs)((0, $e0ad75fff14524ce$export$2e2bcd8739ae039), {
                        href: item["@id"],
                        children: [
                            item["@id"] === (root || "/") && /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $40b74fc137e2741c$export$2e2bcd8739ae039), {
                                size: "S"
                            }),
                            item.title
                        ]
                    })
                }, item["@id"])
        })
    });
}



// @ts-ignore
function $e12e993f00273e98$export$cc56411ddc6ec102(Component, props) {
    // Just in case we define the defaultProps in a Component
    // it will be taken into account
    const { defaultProps: defaultProps = {} } = Component;
    if (props.as && props.as !== defaultProps.as) return props.as;
    return defaultProps.as || "div";
}



const $12c6bd21f5891f0e$var$Container = (props)=>{
    const { children: children, className: className, layout: layout, narrow: narrow, ...rest } = props;
    const classes = (0, $6Dj3b$classnames)("a", "container", className, {
        layout: layout,
        narrow: narrow
    });
    const Component = (0, $e12e993f00273e98$export$cc56411ddc6ec102)($12c6bd21f5891f0e$var$Container, props);
    return /*#__PURE__*/ (0, $6Dj3b$jsx)(Component, {
        ...rest,
        className: classes,
        children: children
    });
};
var $12c6bd21f5891f0e$export$2e2bcd8739ae039 = $12c6bd21f5891f0e$var$Container;






function $35b73b5c7bff9bef$export$2e2bcd8739ae039({ title: title, description: description, error: error, ...props }) {
    return /*#__PURE__*/ (0, $6Dj3b$jsxs)((0, $6Dj3b$TextField), {
        ...props,
        className: (0, $6Dj3b$classnames)("q field", `field-${props.name}`),
        "data-required": props.isRequired || undefined,
        children: [
            /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$Input), {
                className: (0, $6Dj3b$classnames)("q input", {
                    error: error
                })
            }),
            /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$Label), {
                className: "q label",
                children: title
            }),
            /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$FieldError), {
                className: "q assist",
                children: error
            }),
            description && /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$Text), {
                slot: "description",
                className: "q hint",
                children: description
            })
        ]
    });
}








const $caa6a423383b6d56$var$Chevrondown = (props)=>{
    return /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $c4f5db3caac4ef5a$export$2e2bcd8739ae039), {
        ...props,
        children: /*#__PURE__*/ (0, $6Dj3b$jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            children: /*#__PURE__*/ (0, $6Dj3b$jsx)("path", {
                fillRule: "evenodd",
                d: "M5.29297 9.70718L6.70718 8.29297L12.0001 13.5859L17.293 8.29297L18.7072 9.70718L12.0001 16.4143L5.29297 9.70718Z",
                clipRule: "evenodd"
            })
        })
    });
};
var $caa6a423383b6d56$export$2e2bcd8739ae039 = $caa6a423383b6d56$var$Chevrondown;




const $0fbc598f2382559f$var$Chevronup = (props)=>{
    return /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $c4f5db3caac4ef5a$export$2e2bcd8739ae039), {
        ...props,
        children: /*#__PURE__*/ (0, $6Dj3b$jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            children: /*#__PURE__*/ (0, $6Dj3b$jsx)("path", {
                fillRule: "evenodd",
                d: "M18.707 14.2928L17.2928 15.707L11.9999 10.4141L6.70703 15.707L5.29282 14.2928L11.9999 7.58571L18.707 14.2928Z",
                clipRule: "evenodd"
            })
        })
    });
};
var $0fbc598f2382559f$export$2e2bcd8739ae039 = $0fbc598f2382559f$var$Chevronup;


function $bce5ffab2cce5539$export$2e2bcd8739ae039({ title: title, description: description, error: error, children: children, items: items, ...props }) {
    return /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$Select), {
        ...props,
        className: (0, $6Dj3b$classnames)("q field", `field-${props.name}`),
        children: ({ isOpen: isOpen })=>/*#__PURE__*/ (0, $6Dj3b$jsxs)((0, $6Dj3b$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $6Dj3b$jsxs)((0, $6Dj3b$Button), {
                        className: (0, $6Dj3b$classnames)("q input", {
                            error: error
                        }),
                        children: [
                            /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$SelectValue), {}),
                            /*#__PURE__*/ (0, $6Dj3b$jsx)("span", {
                                "aria-hidden": "true",
                                style: {
                                    display: "flex"
                                },
                                children: isOpen ? /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $0fbc598f2382559f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $caa6a423383b6d56$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$Label), {
                        className: "q label",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$FieldError), {
                        className: "q assist",
                        children: error
                    }),
                    description && /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$Text), {
                        slot: "description",
                        className: "q hint",
                        children: description
                    }),
                    /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$Popover), {
                        offset: 1,
                        children: /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$ListBox), {
                            className: "q dropdown",
                            items: items,
                            children: children
                        })
                    })
                ]
            })
    });
}





function $9bbc49dbfc9a1f23$export$2e2bcd8739ae039({ title: title, description: description, error: error, ...props }) {
    return /*#__PURE__*/ (0, $6Dj3b$jsxs)((0, $6Dj3b$TextField), {
        ...props,
        className: (0, $6Dj3b$classnames)("q field", `field-${props.name}`),
        children: [
            /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$TextArea), {
                className: (0, $6Dj3b$classnames)("q textarea input", {
                    error: error
                })
            }),
            /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$Label), {
                className: "q label",
                children: title
            }),
            /*#__PURE__*/ (0, $6Dj3b$jsx)("div", {
                className: "resizer"
            }),
            description && /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$Text), {
                slot: "description",
                className: "q hint",
                children: description
            }),
            /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$FieldError), {
                className: "q assist",
                children: error
            })
        ]
    });
}






function $8c94e099ead98cf3$export$714eb6130bf46a10(content) {
    return (0, $6Dj3b$find)((0, $6Dj3b$keys)(content), (key)=>key !== "volto.blocks" && (0, $6Dj3b$endsWith)(key, "blocks")) !== undefined;
}



const $570911b7a71f66f1$var$DefaultBlockView = ()=>{
    return /*#__PURE__*/ (0, $6Dj3b$jsx)((0, $6Dj3b$Fragment), {
        children: "This block has no view assigned"
    });
};
var $570911b7a71f66f1$export$2e2bcd8739ae039 = $570911b7a71f66f1$var$DefaultBlockView;


const $9dbf44156d0c3157$var$RenderBlocks = (props)=>{
    const { blocksConfig: blocksConfig, content: content, location: location, metadata: metadata } = props;
    const CustomTag = props.as || (0, $6Dj3b$Fragment1);
    return (0, $8c94e099ead98cf3$export$714eb6130bf46a10)(content) ? /*#__PURE__*/ (0, $6Dj3b$jsx)(CustomTag, {
        children: (0, $6Dj3b$map)(content.blocks_layout.items, (block)=>{
            const blockData = content.blocks?.[block];
            const blockType = blockData?.["@type"];
            const Block = blocksConfig[blockType]?.view || (0, $570911b7a71f66f1$export$2e2bcd8739ae039);
            return Block ? /*#__PURE__*/ (0, $6Dj3b$jsx)(Block, {
                id: block,
                metadata: metadata,
                properties: content,
                data: blockData,
                path: location?.pathname || "",
                blocksConfig: blocksConfig
            }) : blockData ? /*#__PURE__*/ (0, $6Dj3b$jsxs)("div", {
                children: [
                    "Unknown block found: ",
                    blockType
                ]
            }, block) : /*#__PURE__*/ (0, $6Dj3b$jsx)("div", {
                children: "Invalid Block"
            }, block);
        })
    }) : "";
};
var $9dbf44156d0c3157$export$2e2bcd8739ae039 = $9dbf44156d0c3157$var$RenderBlocks;






export {$6b2a92710cce9598$export$2e2bcd8739ae039 as Breadcrumbs, $12c6bd21f5891f0e$export$2e2bcd8739ae039 as Container, $c4f5db3caac4ef5a$export$2e2bcd8739ae039 as Icon, $35b73b5c7bff9bef$export$2e2bcd8739ae039 as Input, $e0ad75fff14524ce$export$2e2bcd8739ae039 as Link, $bce5ffab2cce5539$export$2e2bcd8739ae039 as Select, $9bbc49dbfc9a1f23$export$2e2bcd8739ae039 as TextArea, $9dbf44156d0c3157$export$2e2bcd8739ae039 as RenderBlocks, $570911b7a71f66f1$export$2e2bcd8739ae039 as DefaultBlockView, $831ef06765710a2e$export$dccdf695657a545e as FlattenToAppURLProvider, $831ef06765710a2e$export$b0c945b8a6993b4d as useFlattenToAppURL};
//# sourceMappingURL=index.js.map
